import React from "react";
import { Grid, Typography } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import * as Constants from "../../../../../consts/Constants.js";
import Style from "../../../../../styles/js/StyleCallList.js";
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Button from "@material-ui/core/Button";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Tooltip from '@mui/material/Tooltip';
import LaunchIcon from '@mui/icons-material/Launch';
import GroupIcon from '@mui/icons-material/Group';
import LoadingButton from '@mui/lab/LoadingButton';
import CancelIcon from '@mui/icons-material/Cancel';
import ConfirmIcon from '@mui/icons-material/Done';

import alerter from "../../../../alerts/alerter"
import { callStates } from '../../../../../plas/services/calls/models';
import service from '../../../../../plas/services/calls/service';

export default function CallStatus( { openApplications, call, disable, disabled} ) {

  const [changeState, setChangeState] = React.useState(null);
  const [progress, setProgress] = React.useState(false);

  const style = Style();

  const updateState = (newState) => {
    setProgress(true);
    disable(true);
    service.api.calls.changeState(call, newState, (response) => {
      if (response.result != null) {
        call.state = newState;
        setChangeState(null);
      } else {
        alerter.showError(response.error);
      }
      setProgress(false);
      disable(false);
    });
  }


  return (
    <div className={style.box} >
      <Card style={{ marginBottom: "15px"}}>
        <div style={{...call.getStateDescription().style}} className={style.itemHeader}>
          <Typography className={style.titleInitial}>
            { call.getStateDescription().longName }
          </Typography>
        </div>
        <div style={{ padding: "12px"}}>
          <p style={{ fontSize: '17px'}}>
            { call.getStateDescription().actualDescription}
          </p>
          <Divider style={{ marginTop: '12px', marginBottom: '4px' }}/>
          <Grid container direction="row" alignItems="center" style={{padding: '12px'}}>
            <Grid item xs={6}>
              <Grid container direction="row" alignItems="center" justifyContent="center">
                <Grid item>
                  <GroupIcon style={{marginRight: '8px'}} fontSize="small" />
                </Grid>
                <Grid item> 
                  Postulaciones: {call.applications}
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={6}>
              <Grid container direction="row" alignItems="center" justifyContent="center">
                <Grid item > 
                  <Button variant="outlined" style={{textTransform: 'none'}} endIcon={<LaunchIcon />} onClick={openApplications}>
                    Ver postulaciones
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Divider style={{ marginTop: '4px', marginBottom: '4px' }}/>
          <div className={style.itemContent}>
            <Stack spacing={2} justifyContent="center" alignItems="center" direction="row">
              { call.canGoHidden() ? (
                  <Tooltip title={ callStates['hidden'].description}>
                    <Button disabled={disabled} style={{...callStates['hidden'].style, width: '150px'}} variant="contained" onClick={() => setChangeState(1)}><b>Ocultar</b></Button>
                  </Tooltip>
                ) : (null) 
              }
              { call.canGoReady() ? (
                <Tooltip title={ callStates['ready'].description}>
                  <Button disabled={disabled} style={{...callStates['ready'].style, width: '150px'}} variant="contained" onClick={() => setChangeState(2)}><b>Publicar</b></Button>
                </Tooltip>
                ) : (null) 
              }
              { call.canGoSuspended() ? (
                  <Tooltip title={ callStates['suspended'].description}>
                    <Button disabled={disabled} style={{...callStates['suspended'].style, width: '150px'}} variant="contained" onClick={() => setChangeState(3)}><b>Suspender</b></Button>
                  </Tooltip>
                ) : (null) 
              }
              { call.canGoDeleted() ? (
                  <Tooltip title={ callStates['deleted'].description}>
                    <Button disabled={disabled} style={{...callStates['deleted'].style, width: '150px'}} variant="contained" onClick={() => setChangeState(4)}><b>Eliminar</b></Button>
                  </Tooltip>
                ) : (null) 
              }
            </Stack>
          </div>
        </div>
      </Card>

      { changeState ? (
        <Dialog
          open={true}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <DialogTitle>
            ¿{callStates.getByCode(changeState).action} convocatoria?
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              {callStates.getByCode(changeState).description}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button variant="contained" 
              style={{background: Constants.COLOR_GRAY, color: 'white' }}
              disabled={progress}
              startIcon={<CancelIcon/>}
              onClick={ () => { setChangeState(null) } }>
              <b>Cancelar</b>
            </Button>
            <LoadingButton 
              loading={progress}
              startIcon={<ConfirmIcon />}
              loadingPosition="start"
              variant="contained" 
              style={{...callStates.getByCode(changeState).style}} 
              onClick={ () => { updateState(changeState); }} >
                <b>{callStates.getByCode(changeState).action}</b>
            </LoadingButton>
          </DialogActions>
        </Dialog>) : (null) 
      }

    </div>

  );
}
